module.exports = __webpack_public_path__ + "static/pergola-4f38e1222f9676c64b5a2dffa1b33edb.jpg";